module.exports = __webpack_public_path__ + "img/Fitbox Gym.3d7412b4.svg";